// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.field-json-config {
  margin: 10px 0 0 30px;
}
.field-json-config mat-error {
  font-size: 12px;
}
.field-json-config button {
  margin: 20px 0 0 0;
  width: 150px;
}
.field-json-config textarea {
  height: 300px;
  width: 300px;
}

.dynamic-form {
  margin: 10px 60px 0 30px;
}

.super-puper div {
  background: red;
}

.mydocma-required-field-error {
  color: red;
}`, "",{"version":3,"sources":["webpack://./src/app/components/modify-form-config/modify-form-config.component.scss","webpack://./../mydocma-dynamic-form-app%20(dev)/src/app/components/modify-form-config/modify-form-config.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;ACCJ;ADCI;EACI,eAAA;ACCR;ADEI;EACI,kBAAA;EACA,YAAA;ACAR;ADGI;EACI,aAAA;EACA,YAAA;ACDR;;ADKA;EACI,wBAAA;ACFJ;;ADMI;EACI,eAAA;ACHR;;ADOA;EACI,UAAA;ACJJ","sourcesContent":[".field-json-config {\r\n    margin: 10px 0 0 30px;\r\n\r\n    mat-error {\r\n        font-size: 12px;\r\n    }\r\n\r\n    button {\r\n        margin: 20px 0 0 0;\r\n        width: 150px;\r\n    }\r\n\r\n    textarea {\r\n        height: 300px;\r\n        width: 300px;\r\n    }\r\n}\r\n\r\n.dynamic-form {\r\n    margin: 10px 60px 0 30px;\r\n}\r\n\r\n.super-puper {\r\n    div {\r\n        background: red;\r\n    }\r\n}\r\n\r\n.mydocma-required-field-error {\r\n    color: red;\r\n}\r\n",".field-json-config {\n  margin: 10px 0 0 30px;\n}\n.field-json-config mat-error {\n  font-size: 12px;\n}\n.field-json-config button {\n  margin: 20px 0 0 0;\n  width: 150px;\n}\n.field-json-config textarea {\n  height: 300px;\n  width: 300px;\n}\n\n.dynamic-form {\n  margin: 10px 60px 0 30px;\n}\n\n.super-puper div {\n  background: red;\n}\n\n.mydocma-required-field-error {\n  color: red;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
